// Redirect sign-in via Authentik's own login page. Used when the in-page login
// is unavailable or a stage needs Authentik's UI (passkeys, external providers).

const DEFAULT_AUTHENTIK_URL = process.env.REACT_APP_AUTHENTIK_URL || 'https://idp.netx.as';
const DEFAULT_CLIENT_ID = process.env.REACT_APP_AUTHENTIK_CLIENT_ID || 'Rvph8In5PfF0PKWDglQFZ0OCFbzUBVDun4aFqELG';
const DEFAULT_SCOPES = 'openid profile group_attributes email';

export function authentikHost(sso) {
    try {
        return new URL(sso?.authentik_url || DEFAULT_AUTHENTIK_URL).host;
    } catch {
        return 'idp.netx.as';
    }
}

export function buildAuthentikRedirectUrl(returnPath, sso) {
    const base = String(sso?.authentik_url || DEFAULT_AUTHENTIK_URL).replace(/\/+$/, '');
    const params = new URLSearchParams({
        client_id: sso?.client_id || DEFAULT_CLIENT_ID,
        redirect_uri: `${window.location.origin}/callback`,
        response_type: 'code',
        scope: sso?.scopes || DEFAULT_SCOPES,
        state: JSON.stringify({ returnUrl: returnPath }),
    });
    return `${base}/application/o/authorize/?${params.toString()}`;
}

export function redirectToAuthentik(returnPath, sso) {
    window.location.assign(buildAuthentikRedirectUrl(returnPath, sso));
}
